import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
  },
  actions: {
    margin: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  item: {
    padding: theme.spacing(1),
  },
}))
